import fetchMock from 'fetch-mock';
import noUiSlider from 'nouislider';
import autocomplete from 'autocompleter';
import {fetch as whatwgFetch} from 'whatwg-fetch';

const urlBase = 'https://tutgutfinal.webdemos.at/';

const endpoints = {
  wanderwege: {
    default: urlBase + '/api/wanderwege?id=api2',
    list: urlBase + '/api/wanderwegeListe?id=api2',
    detail: urlBase + '/api/wanderwegeDetail?id=api2',
  },
  schrittewege: {
    default: urlBase + '/api/schrittewege?id=api2',
    list: urlBase + '/api/schrittewegeListe?id=api2',
    detail: urlBase + '/api/schrittewegeDetail?id=api2',
  }
}

// start mock-definitionstabRoot: document.querySelector('.c-map__tabs'),

const initFetchMocks = () => {
  fetchMock.post(endpoints.wanderwege.list, {
    list: [
      {
        name: 'ww_ind_Ort001',
        distance: 2500,
        difficulty: 'medium',
        duration: 3600, // 1h
      },
      {
        name: 'ww_ind_Ort002',
        distance: 3000,
        difficulty: 'hard',
        duration: 7200, // 2h
      },
      {
        name: 'ww_ind_Ort003',
        distance: 2500,
        difficulty: 'easy',
        duration: 1800, // 0,5h
      },
    ],
  });

  fetchMock.post(endpoints.schrittewege.list, {
    list: [
      {
        name: 'sw_ind_Ort001',
        distance: 2500,
        duration: 3600, // 1h
      },
      {
        name: 'sw_ind_Ort002',
        distance: 3000,
        duration: 7200, // 2h
      },
      {
        name: 'sw_ind_Ort003',
        distance: 2500,
        duration: 1800, // 0,5h
      },
    ],
  });

  fetchMock.post(endpoints.wanderwege.default, {
    checkboxes: {
      difficultyEasy: false,
      difficultyMedium: false,
      difficultyHard: false,
      wanderwegeWanderwirt: false,
      wanderwegeBuggy: false,
      wanderwegePlayground: false,
      schrittewegeGasthaus: false,
      schrittewegeBuggy: false,
      schrittewegePlayground: false,
    },
    sliders: {
      distance: {
        min: 1.9,
        max: 17.5,
      },
      time: {
        min: 0.1,
        max: 2.75,
      },
      height: {
        min: 2,
        max: 1020,
      },
    },
    regions: [
      {
        id: 0,
        name: 'Industrieviertel',
        places: [
          {
            id: 1000,
            name: 'ww_ind_Ort001',
          },
          {
            id: 1001,
            name: 'ww_ind_Ort002',
          },
          {
            id: 1002,
            name: 'ww_ind_Ort003',
          }
        ]
      },
      {
        id: 1,
        name: 'Mostviertel',
        places: [
          {
            id: 1100,
            name: 'ww_most_Ort001',
          },
          {
            id: 1101,
            name: 'ww_most_Ort002',
          },
          {
            id: 1102,
            name: 'ww_most_Ort003',
          }
        ]
      },
      {
        id: 2,
        name: 'NÖ Mitte',
        places: [
          {
            id: 1200,
            name: 'ww_mitt_Ort001',
          },
          {
            id: 1201,
            name: 'ww_mitt_Ort002',
          },
          {
            id: 1202,
            name: 'ww_mitt_Ort003',
          }
        ]
      },
      {
        id: 3,
        name: 'Waldviertel',
        places: [
          {
            id: 1300,
            name: 'ww_wald_Ort001',
          },
          {
            id: 1301,
            name: 'ww_wald_Ort002',
          },
          {
            id: 1302,
            name: 'ww_wald_Ort003',
          }
        ]
      },
      {
        id: 4,
        name: 'Weinviertel',
        places: [
          {
            id: 1400,
            name: 'ww_wein_Ort001',
          },
          {
            id: 1401,
            name: 'ww_wein_Ort002',
          },
          {
            id: 1402,
            name: 'ww_wein_Ort003',
          }
        ]
      },
    ]
  });

  fetchMock.post(endpoints.schrittewege.default, {
    checkboxes: {
      difficultyEasy: false,
      difficultyMedium: false,
      difficultyHard: false,
      wanderwegeWanderwirt: false,
      wanderwegeBuggy: false,
      wanderwegePlayground: false,
    },
    sliders: {
      distance: {
        min: 2.3,
        max: 11.5,
      },
      time: {
        min: 1.1,
        max: 3.75,
      },
      height: {
        min: 44,
        max: 600,
      },
    },
    regions: [
      {
        id: 0,
        name: 'Industrieviertel',
        places: [
          {
            id: 1000,
            name: 'sw_ind_Ort001',
          },
          {
            id: 1001,
            name: 'sw_ind_Ort002',
          },
          {
            id: 1002,
            name: 'sw_ind_Ort003',
          }
        ]
      },
      {
        id: 1,
        name: 'Mostviertel',
        places: [
          {
            id: 1100,
            name: 'sw_most_Ort001',
          },
          {
            id: 1101,
            name: 'sw_most_Ort002',
          },
          {
            id: 1102,
            name: 'sw_most_Ort003',
          }
        ]
      },
      {
        id: 2,
        name: 'NÖ Mitte',
        places: [
          {
            id: 1200,
            name: 'sw_mitt_Ort001',
          },
          {
            id: 1201,
            name: 'sw_mitt_Ort002',
          },
          {
            id: 1202,
            name: 'sw_mitt_Ort003',
          }
        ]
      },
      {
        id: 3,
        name: 'Waldviertel',
        places: [
          {
            id: 1300,
            name: 'sw_wald_Ort001',
          },
          {
            id: 1301,
            name: 'sw_wald_Ort002',
          },
          {
            id: 1302,
            name: 'sw_wald_Ort003',
          }
        ]
      },
      {
        id: 4,
        name: 'Weinviertel',
        places: [
          {
            id: 1400,
            name: 'sw_wein_Ort001',
          },
          {
            id: 1401,
            name: 'sw_wein_Ort002',
          },
          {
            id: 1402,
            name: 'sw_wein_Ort003',
          }
        ]
      },
    ]
  });

  // end mock-definitions

  //FETCH-MOCK DETAIL START

  fetchMock.get(endpoints.wanderwege.detail, { // + id
    legend: [
      'kirche', 'festes_schuhwerk', 'spielplatz', 'wanderwirt', 'ausblick'
    ],
    checkpoints: [
      'Thermenhotel2',
      'Dechant-Bischinger-Promenade',
      'Mühldamm',
      'Wehrgärten',
      'Reckturm',
      'Eisteich',
      'Schillerpark',
      'Schubertpark',
      'Thermenhotel',
    ],
    anreise: 'Thermenplatz 4, 2136 Laa an der Thaya',
    charakteristika: `
      Im nördlichen Weinviertel liegt eingebettet in eine sanfte Hügellandschaft das Land um Laa an der Thaya. Nutzen Sie einen Ausﬂug mit Ihrer Familie und bewundern Sie die weitgehend unberührte Landschaft mit beschaulichen Pfaden. Fast mitten in der Stadt und doch ganz nah können Sie hier Natur pur sowie eine Vielfalt an Pﬂanzen und Tieren erleben! Schon lange gilt diese Region als Geheimtipp bei Erholungsuchenden und Wochenendgästen und bietet eine Fülle von Angeboten für Naturliebhaber!
      <br><br>
      Webseite der Gemeinde: www.laa.at
    `,
    wanderwirte: [
      {
        bezeichnung: "THERME LAA – HOTEL & SILENT SPA",
        adresse: `
          Thermenplatz 3<br>
          2136 Laa an der Thaya<br>
          Tel: +43 2522 847009602<br>
          E-Mail: hotel@therme-laa.at<br>
          http://www.therme-laa.at
        `,
      }
      ,
      {
        bezeichnung: "WALDGASTHAUS LINDENHOF",
        adresse: `
          Hanfthal, Parz. 911<br>
          2136 Laa an der Thaya<br>
          Tel: +43 2522 8040<br>
          E-Mail: lindenhof@nanet.at
        `,
      }
    ],
    downloads: [
      {
        typ: 'pdf',
        bezeichnung: 'Wanderkarte PDF',
        url: 'http://orf.at'
      },
      {
        typ: 'gpx',
        bezeichnung: 'Wanderkarte GPX Route 1',
        url: 'http://orf.at'
      },
      {
        typ: 'gpx',
        bezeichnung: 'Wanderkarte GPX Route 2',
        url: 'http://orf.at'
      },
    ],
    routes: [
      {
        time: 2500,
        difficulty: 'medium',
        distance: 100,
        steps: 2000,
        height: 200,
        gpx: 'Laa_an_der_Thaya_Route1.gpx',
      },
      {
        time: 1500,
        difficulty: 'hard',
        distance: 100,
        steps: 1000,
        height: 500,
        gpx: 'Laa_an_der_Thaya_Route2.gpx',
      },
      {
        time: 2500,
        difficulty: 'easy',
        distance: 100,
        steps: 3000,
        height: 300,
        gpx: 'Laa_an_der_Thaya_Route3.gpx',
      },
    ],
    imgURLs: [
      {
        thumb: 'assets/images/gallery/bewegte-klasse-thumb.jpg',
        big: 'assets/images/gallery/bewegte-klasse.jpg',
        caption: 'caption 1',
        dataSize: '800x352',
      },
      {
        thumb: 'assets/images/gallery/bewegte-klasse-thumb.jpg',
        big: 'assets/images/gallery/bewegte-klasse.jpg',
        caption: 'caption 2',
        dataSize: '800x352',
      },
      {
        thumb: 'assets/images/gallery/bewegte-klasse-thumb.jpg',
        big: 'assets/images/gallery/bewegte-klasse.jpg',
        caption: 'caption 3',
        dataSize: '800x352',
      },
      {
        thumb: 'assets/images/gallery/bewegte-klasse-thumb.jpg',
        big: 'assets/images/gallery/bewegte-klasse.jpg',
        caption: 'caption 4',
        dataSize: '800x352',
      },
    ]
  });

  fetchMock.get(endpoints.schrittewege.detail, { // + id
    legend: [
      'festes_schuhwerk', 'kirche', 'spielplatz', 'wanderwirt', 'ausblick'
    ],
    checkpoints: [
      'Thermenhotel',
      'Dechant-Bischinger-Promenade',
      'Mühldamm',
      'Wehrgärten',
      'Reckturm',
      'Eisteich',
      'Schillerpark',
      'Schubertpark',
      'Thermenhotel',
    ],
    anreise: 'Thermenplatz 4, 2136 Laa an der Thaya',
    charakteristika: `
      Im nördlichen Weinviertel liegt eingebettet in eine sanfte Hügellandschaft das Land um Laa an der Thaya. Nutzen Sie einen Ausﬂug mit Ihrer Familie und bewundern Sie die weitgehend unberührte Landschaft mit beschaulichen Pfaden. Fast mitten in der Stadt und doch ganz nah können Sie hier Natur pur sowie eine Vielfalt an Pﬂanzen und Tieren erleben! Schon lange gilt diese Region als Geheimtipp bei Erholungsuchenden und Wochenendgästen und bietet eine Fülle von Angeboten für Naturliebhaber!
      <br><br>
      Webseite der Gemeinde: www.laa.at
    `,
    wanderwirte: [
      {
        bezeichnung: "THERME LAA – HOTEL & SILENT SPA",
        adresse: `
          Thermenplatz 3<br>
          2136 Laa an der Thaya<br>
          Tel: +43 2522 847009602<br>
          E-Mail: hotel@therme-laa.at<br>
          http://www.therme-laa.at
        `,
      }
      ,
      {
        bezeichnung: "WALDGASTHAUS LINDENHOF",
        adresse: `
          Hanfthal, Parz. 911<br>
          2136 Laa an der Thaya<br>
          Tel: +43 2522 8040<br>
          E-Mail: lindenhof@nanet.at
        `,
      }
    ],
    downloads: [
      {
        typ: 'pdf',
        bezeichnung: 'Wanderkarte PDF',
        url: 'http://orf.at'
      },
      {
        typ: 'gpx',
        bezeichnung: 'Wanderkarte GPX Route 1',
        url: 'http://orf.at'
      },
      {
        typ: 'gpx',
        bezeichnung: 'Wanderkarte GPX Route 2',
        url: 'http://orf.at'
      },
    ],
    routes: [
      {
        id: 1000,
        time: 2500,
        distance: 100,
        steps: 2000,
        height: 200,
        gpx: 'Laa_an_der_Thaya_Route1.gpx',
      },
      {
        id: 1001,
        time: 1500,
        distance: 100,
        steps: 1000,
        height: 500,
        gpx: 'Laa_an_der_Thaya_Route2.gpx',
      },
      {
        id: 1002,
        time: 2500,
        distance: 100,
        steps: 3000,
        height: 300,
        gpx: 'Laa_an_der_Thaya_Route3.gpx',
      },
    ],
    imgURLs: [
      {
        thumb: 'assets/images/gallery/bewegte-klasse-thumb.jpg',
        big: 'assets/images/gallery/bewegte-klasse.jpg',
        caption: 'caption 1',
        dataSize: '800x352',
      },
      {
        thumb: 'assets/images/gallery/bewegte-klasse-thumb.jpg',
        big: 'assets/images/gallery/bewegte-klasse.jpg',
        caption: 'caption 2',
        dataSize: '800x352',
      },
      {
        thumb: 'assets/images/gallery/bewegte-klasse-thumb.jpg',
        big: 'assets/images/gallery/bewegte-klasse.jpg',
        caption: 'caption 3',
        dataSize: '800x352',
      },
      {
        thumb: 'assets/images/gallery/bewegte-klasse-thumb.jpg',
        big: 'assets/images/gallery/bewegte-klasse.jpg',
        caption: 'caption 4',
        dataSize: '800x352',
      },
    ]
  });

  //FETCH-MOCK DETAIL END
}

if (window.location.search.indexOf('mockApi') != -1) {
  initFetchMocks();
}
else {
}

window.hikingData = {
  type: 'wanderwege',
  htmlNodes: {},
  detail: {},
  legendMap: {
    festes_schuhwerk: {
      description: 'Festes Schuhwerk',
      fileUrl: 'assets/images/icons/hiking/Festes-Schuhwerk.png',
    },
    kirche: {
      description: 'Kirche',
      fileUrl: 'assets/images/icons/hiking/Kirche.png',
    },
    ausblick: {
      description: 'Schöner Ausblick',
      fileUrl: 'assets/images/icons/hiking/Schöner-Ausblick.png',
    },
    wanderwirt: {
      description: 'Wanderwirt',
      fileUrl: 'assets/images/icons/hiking/Wanderwirt.png',
    },
    spielplatz: {
      description: 'Spielplatz',
      fileUrl: 'assets/images/icons/hiking/Spielplatz.png',
    },
  },
}

const typeSwitch = () => {
  window.hikingData.type = 'wanderwege';
  if (window.hikingData.htmlNodes.switcher.classList.contains('mode-wanderwege')) {
    window.hikingData.type = 'schrittewege';
  }
  window.hikingData.htmlNodes.extras.classList.add('c-hiking__hidden');
  // changes htmlNodes
  initHikingData();
  window.hikingData.htmlNodes.extras.classList.remove('c-hiking__hidden');

  if (window.hikingData.type == 'schrittewege') {
    window.hikingData.htmlNodes.switcher.classList.remove('mode-wanderwege');
    window.hikingData.htmlNodes.switcher.classList.add('mode-schrittewege');
    window.hikingData.htmlNodes.difficultyParent.classList.add('c-hiking__hidden');
    
  }
  else {
    window.hikingData.htmlNodes.switcher.classList.remove('mode-schrittewege');
    window.hikingData.htmlNodes.switcher.classList.add('mode-wanderwege');
    window.hikingData.htmlNodes.difficultyParent.classList.remove('c-hiking__hidden');
  }
}

const initHikingData = callback => {
  if (!window.hikingData || !window.hikingData.type) {
    return;
  }
  window.hikingData.didInitOnce = window.hikingData.didInitOnce || false;
  window.hikingData.checkboxes = {};
  window.hikingData.regions = [];
  window.hikingData.sliders = {};
  window.hikingData.htmlNodes = {
    googleMap: document.querySelector('.google-map'),
    googleMapIndexParent: document.querySelector('.c-hiking__selection'),
    googleMapDetailParent: document.querySelector('.c-wrapper-detail'),
    googleMapDetailBefore: document.querySelector('.c-map__tabs'),
    mainWrapper: document.querySelector('.o-main'),
    overlayRoot: document.querySelector('.c-hiking__searchbar'),
    regionsEntrypoint: document.querySelector('.regions-entrypoint'),
    searchInput: document.querySelector('.c-hiking__select-1 .c-form__input'),
    switcher: document.querySelector('.c-hiking__switcher'),
    switcherWanderwege: document.querySelector('.c-btn__wanderwege'),
    switcherSchrittewege: document.querySelector('.c-btn__schrittewege'),
    distanceFrom: document.querySelector('.c-range__label-distance-from'),
    distanceTo: document.querySelector('.c-range__label-distance-to'),
    timeFrom: document.querySelector('.c-range__label-time-from'),
    timeTo: document.querySelector('.c-range__label-time-to'),
    heightFrom: document.querySelector('.c-range__label-height-from'),
    heightTo: document.querySelector('.c-range__label-height-to'),
    difficultyParent: document.querySelector('.c-hiking__difficulty'),
    boxError: document.querySelector('.c-hiking__box-error'),
    boxErrorNoDifficulty: document.querySelector('.c-hiking__box-error-nodifficulty'),
    boxErrorNoResults: document.querySelector('.c-hiking__box-error-noresults'),
    filterCloud: document.querySelector('.c-hiking__filter-cloud'),
    submitButton: document.querySelector('.c-btn'),
    resultList: document.querySelector('.c-hiking__result-list'),

    // detail
    tabRoot: document.querySelector('.c-map__tabs'),
    legendRoot: document.querySelector('.c-hiking__icons'),
    checkpoints: document.querySelector(".c-hiking__desc p:first-child"),
    anreise: document.querySelector(".c-hiking__desc p:last-child a"),
    galleryRoot: document.querySelector(".c-gallery"),
    charakteristika: document.querySelector(".c-charakteristika"),
    wanderwirte: document.querySelector(".c-wanderwirte"),
    downloads: document.querySelector(".c-downloads"),

    titleTag: document.querySelector('.c-wrapper-detail .c-title__mainheader'),
    breadcrumbSubTag: document.querySelector('.c-wrapper-detail .c-breadcrumbs__name:nth-child(2)'),
  };
  replaceGoogleMap('index');
  if (window.hikingData.type == 'wanderwege') {
    window.hikingData.htmlNodes = {
      ...window.hikingData.htmlNodes,
      ...{
        extras: document.querySelector('.c-hiking__extras-wanderwege'),
      }
    }
    initHikingDataFromServer(callback);
  }
  else if (window.hikingData.type == 'schrittewege') {
    window.hikingData.htmlNodes = {
      ...window.hikingData.htmlNodes,
      ...{
        extras: document.querySelector('.c-hiking__extras-schrittewege'),
      }
    }
    initHikingDataFromServer(callback);
  }
  if (!window.hikingData.didInitOnce) {
    window.hikingData.htmlNodes.switcherWanderwege.addEventListener('click', typeSwitch);
    window.hikingData.htmlNodes.switcherSchrittewege.addEventListener('click', typeSwitch);
  }
}

const updateHikingRangeLabels = () => {
  window.hikingData.htmlNodes.distanceFrom.innerHTML = window.hikingData.sliders.distance.curMin || window.hikingData.sliders.distance.min;
  window.hikingData.htmlNodes.distanceTo.innerHTML = window.hikingData.sliders.distance.curMax || window.hikingData.sliders.distance.max;
  window.hikingData.htmlNodes.timeFrom.innerHTML = window.hikingData.sliders.time.curMin || window.hikingData.sliders.time.min;
  window.hikingData.htmlNodes.timeTo.innerHTML = window.hikingData.sliders.time.curMax || window.hikingData.sliders.time.max;
  window.hikingData.htmlNodes.heightFrom.innerHTML = window.hikingData.sliders.height.curMin || window.hikingData.sliders.height.min;
  window.hikingData.htmlNodes.heightTo.innerHTML = window.hikingData.sliders.height.curMax || window.hikingData.sliders.height.max;
  hideErrorBox();
}

const initHikingDataFromServer = callback => {
  if (!window.hikingData || !window.hikingData.type) {
    return;
  }
  fetch(endpoints[window.hikingData.type].default, {
    method: 'post',
    credentials: 'include',
  }).then(response => response.json())
  .then(response => {
    window.hikingData.checkboxes = response.checkboxes;
    window.hikingData.sliders = response.sliders;
    window.hikingData.sliders.distance.curMin = window.hikingData.sliders.distance.min;
    window.hikingData.sliders.distance.curMax = window.hikingData.sliders.distance.max;
    window.hikingData.sliders.time.curMin = window.hikingData.sliders.time.min;
    window.hikingData.sliders.time.curMax = window.hikingData.sliders.time.max;
    window.hikingData.sliders.height.curMin = window.hikingData.sliders.height.min;
    window.hikingData.sliders.height.curMax = window.hikingData.sliders.height.max;
    window.hikingData.regions = response.regions;
    window.hikingData.htmlNodes.regionsEntrypoint.innerHTML = "";
    updateHikingRangeLabels();
    response.regions.map(region => {
      let accordionHeader = document.createElement('h2');
      let accordionPanel = document.createElement('div');
      accordionHeader.innerHTML = region.name;
      accordionHeader.classList.add('js-accordion__header');
      accordionPanel.setAttribute("data-id", region.id);
      accordionPanel.classList.add('js-accordion__panel');
      accordionPanel.innerHTML = `
        <ul>
          ${
            region.places.map(place => {
              return '<li data-id="'+place.id+'">'
                + '<a href="#" onclick="window.goToDetailsPage('+place.id+')">'
                + place.name
                + '</a>'
                + '</li>'
              ;
            }).join('')
          }
        </ul>
      `;
      window.hikingData.htmlNodes.regionsEntrypoint.appendChild(accordionHeader);
      window.hikingData.htmlNodes.regionsEntrypoint.appendChild(accordionPanel);
    });
    var expand_default = window.van11yAccessibleAccordionAria();
    expand_default.attach();
    document.querySelector('.regions-entrypoint').classList.add('has-data');
    if (window.hikingData.autocomplete) {
      window.hikingData.autocomplete.destroy();
    }
    window.hikingData.autocomplete = autocomplete({
      input: window.hikingData.htmlNodes.searchInput,
      fetch: function(text, update) {
          text = text.toLowerCase();
          // you can also use AJAX requests instead of preloaded data
          let placesTmpArr = response.regions.map(region => region.places);
          let placesArr = [];
          placesTmpArr.map(place => {
            placesArr = [
              ...placesArr,
              ...place
            ];
          });
          var suggestions = placesArr.filter(n => n.name.toLowerCase().startsWith(text));
          suggestions = suggestions.map(s => ({label: s.name, value: s.id}));
          update(suggestions);
      },
      onSelect: function(item) {
        window.hikingData.htmlNodes.searchInput.value = item.label;
      }
    });

    // sliders init
    initSliders();
    callback();
  });
}

const initSliders = () => {
  let sliderElementDistance = document.querySelector('.js-hiking-select .c-doublerange-distance');

  if (sliderElementDistance.noUiSlider) {
   sliderElementDistance.noUiSlider.destroy(); 
  }

  noUiSlider.create(sliderElementDistance, {
    start: [window.hikingData.sliders.distance.min, window.hikingData.sliders.distance.max],
    range: {
      min: [window.hikingData.sliders.distance.min - .0],
      max: [window.hikingData.sliders.distance.max + .0],
    },
    padding: [.0,.0],
    connect: true,
    step: 0.1,
  });
  
  sliderElementDistance.noUiSlider.on('change.one', m => {
    window.hikingData.sliders.distance.curMin = m[0];
    window.hikingData.sliders.distance.curMax = m[1];
    updateHikingRangeLabels();
  });

  let sliderElementTime = document.querySelector('.js-hiking-select .c-doublerange-time');

  if (sliderElementTime.noUiSlider) {
    sliderElementTime.noUiSlider.destroy(); 
  }

  noUiSlider.create(sliderElementTime, {
    start: [window.hikingData.sliders.time.min, window.hikingData.sliders.time.max],
    range: {
      min: [window.hikingData.sliders.time.min - .0],
      max: [window.hikingData.sliders.time.max + .0],
    },
    padding: [.0,.0],
    connect: true,
    step: 0.1,
  });
  
  sliderElementTime.noUiSlider.on('change.one', m => {
    window.hikingData.sliders.time.curMin = m[0];
    window.hikingData.sliders.time.curMax = m[1];
    updateHikingRangeLabels();
  });

  let sliderElementHeight = document.querySelector('.js-hiking-select .c-doublerange-height');

  if (sliderElementHeight.noUiSlider) {
    sliderElementHeight.noUiSlider.destroy(); 
  }

  noUiSlider.create(sliderElementHeight, {
    start: [window.hikingData.sliders.height.min, window.hikingData.sliders.height.max],
    range: {
      min: [window.hikingData.sliders.height.min - .0],
      max: [window.hikingData.sliders.height.max + .0],
    },
    padding: [.0,.0],
    connect: true,
    step: 0.1,
  });
  
  sliderElementHeight.noUiSlider.on('change.one', m => {
    window.hikingData.sliders.height.curMin = m[0];
    window.hikingData.sliders.height.curMax = m[1];
    updateHikingRangeLabels();
  });
  updateHikingRangeLabels();
} 

window.cbChangeWanderwegDifficultyEasy = e => {
  window.hikingData.checkboxes.difficultyEasy = e.target.checked;
}

window.cbChangeWanderwegDifficultyMedium = e => {
  window.hikingData.checkboxes.difficultyMedium = e.target.checked;
}

window.cbChangeWanderwegDifficultyHard = e => {
  window.hikingData.checkboxes.difficultyHard = e.target.checked;
}

window.cbChangeWanderwegWanderwirt = e => {
  window.hikingData.checkboxes.wanderwegeWanderwirt = e.target.checked;
}

window.cbChangeWanderwegBuggy = e => {
  window.hikingData.checkboxes.wanderwegeBuggy = e.target.checked;
}

window.cbChangeWanderwegPlayground = e => {
  window.hikingData.checkboxes.wanderwegePlayground = e.target.checked;
}

window.cbChangeSchrittewegGasthaus = e => {
  window.hikingData.checkboxes.schrittewegeGasthaus = e.target.checked;
}

window.cbChangeSchrittewegBuggy = e => {
  window.hikingData.checkboxes.schrittewegeBuggy = e.target.checked;
}

window.cbChangeSchrittewegPlayground = e => {
  window.hikingData.checkboxes.schrittewegePlayground = e.target.checked;
}

// type is 'difficulty' or 'results'
const showErrorBox = type => {
  if (type == 'difficulty') {
    window.hikingData.htmlNodes.boxErrorNoDifficulty.classList.remove('c-hiking__hidden');
    window.hikingData.htmlNodes.boxErrorNoResults.classList.add('c-hiking__hidden');
  }
  else if (type == 'results') {
    window.hikingData.htmlNodes.boxErrorNoDifficulty.classList.add('c-hiking__hidden');
    window.hikingData.htmlNodes.boxErrorNoResults.classList.remove('c-hiking__hidden');
  }
  else {
    return;
  }
  window.hikingData.htmlNodes.boxError.classList.remove('c-hiking__hidden');
}

const hideErrorBox = () => {
  window.hikingData.htmlNodes.boxError.classList.add('c-hiking__hidden');
}

window.triggerFilter = e => {
  if (e) e.preventDefault();
  if (window.hikingData.type == 'wanderwege') {
    if (
      window.hikingData.checkboxes.difficultyEasy == false
      && window.hikingData.checkboxes.difficultyMedium == false
      && window.hikingData.checkboxes.difficultyHard == false
    ) {
      showErrorBox('difficulty');
      return;
    }
  }

  if (window.hikingData.latestList && window.hikingData.latestList.length == 1) {
    window.location.href='hiking-detail.html';
  }

  window.hikingData.switchView('results');

  let appendHTML = '';

  [...(window.hikingData.latestList || [])].map(listElement => {
    appendHTML += '<div class="c-hiking__result-list-element" onclick="window.goToDetailsPage('+
      findIdForPlaceName(listElement.name)
    +')">';
    appendHTML += '<div class="c-hiking__result-list-element-title">';
    appendHTML += listElement.name;
    appendHTML += '</div>';
    appendHTML += '<div class="c-hiking__result-list-element-body">';
    appendHTML += '<span class="c-hiking__result-list-distance">';
    appendHTML += listElement.distance + ' Meter';
    appendHTML += '</span>, ';
    if (window.hikingData.type == 'wanderwege') {
      appendHTML += '<span class="c-hiking__result-list-difficulty">';
      appendHTML += listElement.difficulty == 'easy'
                    ? 'einfach'
                    : listElement.difficulty == 'medium'
                      ? 'mittel'
                      : listElement.difficulty == 'hard'
                        ? 'schwierig'
                        : ''
                  ;
      
      appendHTML += '</span>, ';
    }
    appendHTML += '<span class="c-hiking__result-list-duration">';
    appendHTML += listElement.duration + 'h';
    appendHTML += '</span>';
    appendHTML += '</div>';
    appendHTML += '</div>';
  });
  window.hikingData.htmlNodes.resultList.innerHTML = appendHTML;

  //filter-tags
  drawFilterTags();
}

const drawFilterTags = () => {
  window.hikingData.htmlNodes.filterCloud.innerHTML = '';
  if (
    window.hikingData.sliders.distance.min != window.hikingData.sliders.distance.curMin
    || window.hikingData.sliders.distance.max != window.hikingData.sliders.distance.curMax
  ) {
    addElementToFilterCloud(
      window.hikingData.sliders.distance.curMin,
      window.hikingData.sliders.distance.curMax,
      'distance',
    );
  }
  if (
    window.hikingData.sliders.time.min != window.hikingData.sliders.time.curMin
    || window.hikingData.sliders.time.max != window.hikingData.sliders.time.curMax
  ) {
    addElementToFilterCloud(
      window.hikingData.sliders.time.curMin,
      window.hikingData.sliders.time.curMax,
      'time',
    );
  }
  if (
    window.hikingData.sliders.height.min != window.hikingData.sliders.height.curMin
    || window.hikingData.sliders.height.max != window.hikingData.sliders.height.curMax
  ) {
    addElementToFilterCloud(
      window.hikingData.sliders.height.curMin,
      window.hikingData.sliders.height.curMax,
      'height',
    );
  }
  if (window.hikingData.checkboxes.difficultyEasy) {
    addElementToFilterCloud(
      'Einfach',
      null,
      'difficultyEasy',
    );
  }
  if (window.hikingData.checkboxes.difficultyMedium) {
    addElementToFilterCloud(
      'Mittel',
      null,
      'difficultyMedium',
    );
  }
  if (window.hikingData.checkboxes.difficultyHard) {
    addElementToFilterCloud(
      'Schwer',
      null,
      'difficultyHard',
    );
  }
  if (
    window.hikingData.type == 'wanderwege'
  ) {
    if (window.hikingData.checkboxes.wanderwegeBuggy) {
      addElementToFilterCloud(
        'Kinderwagentauglich',
        null,
        'wanderwegeBuggy',
      );
    }
    if (window.hikingData.checkboxes.wanderwegeWanderwirt) {
      addElementToFilterCloud(
        'Wanderwirt',
        null,
        'wanderwegeWanderwirt',
      );
    }
    if (window.hikingData.checkboxes.wanderwegePlayground) {
      addElementToFilterCloud(
        'Spielplatz',
        null,
        'wanderwegePlayground',
      );
    }
  }
  else {
    if (window.hikingData.checkboxes.schrittewegeBuggy) {
      addElementToFilterCloud(
        'Kinderwagentauglich',
        null,
        'schrittewegeBuggy',
      );
    }
    if (window.hikingData.checkboxes.schrittewegeGasthaus) {
      addElementToFilterCloud(
        'Gasthaus',
        null,
        'schrittewegeGasthaus',
      );
    }
    if (window.hikingData.checkboxes.schrittewegePlayground) {
      addElementToFilterCloud(
        'Spielplatz',
        null,
        'schrittewegePlayground',
      );
    }
  }
}

const addElementToFilterCloud = (min, max, type) => {
  let newNode = document.createElement('div');
  newNode.setAttribute('class', 'c-hiking__filter-cloud-element');
  newNode.setAttribute('data-type', type)
  newNode.innerHTML = ''
    + '<span class="c-hiking__filter-cloud-element-icon"'
    + ' onclick="window.hikingData.removeFilter(\''+type+'\')" '
    +'></span>'
    + '<span class="c-hiking__filter-cloud-element-text">'
    + (max ? suffixify(min, type) + ' - ' + suffixify(max, type) : suffixify(min, type))
    + '</span>'
  ;
  window.hikingData.htmlNodes.filterCloud.appendChild(newNode);
}

window.hikingData.removeFilter = type => {
  if (type == 'difficultyEasy') {
    window.hikingData.checkboxes.difficultyMedium = false;
    document.querySelector('.c-form__check #easy').checked = false;
  }
  if (type == 'difficultyMedium') {
    window.hikingData.checkboxes.difficultyMedium = false;
    document.querySelector('.c-form__check #medium').checked = false;
  }
  if (type == 'difficultyHard') {
    window.hikingData.checkboxes.difficultyMedium = false;
    document.querySelector('.c-form__check #hard').checked = false;
  }
  if (type == 'wanderwegeBuggy') {
    window.hikingData.checkboxes.wanderwegeBuggy = false;
    document.querySelector('.c-form__check #buggy').checked = false;
  }
  if (type == 'wanderwegeWanderwirt') {
    window.hikingData.checkboxes.wanderwegeWanderwirt = false;
    document.querySelector('.c-form__check #pub').checked = false;
  }
  if (type == 'wanderwegePlayground') {
    window.hikingData.checkboxes.wanderwegePlayground = false;
    document.querySelector('.c-form__check #playground').checked = false;
  }
  if (type == 'schrittewegeBuggy') {
    window.hikingData.checkboxes.schrittewegeBuggy = false;
    document.querySelector('.c-form__check #sw_buggy').checked = false;
  }
  if (type == 'schrittewegeWanderwirt') {
    window.hikingData.checkboxes.schrittewegeWanderwirt = false;
    document.querySelector('.c-form__check #sw_pub').checked = false;
  }
  if (type == 'schrittewegePlayground') {
    window.hikingData.checkboxes.schrittewegePlayground = false;
    document.querySelector('.c-form__check #sw_playground').checked = false;
  }
  if (type == 'distance') {
    window.hikingData.sliders.distance.curMin = window.hikingData.sliders.distance.min;
    window.hikingData.sliders.distance.curMax = window.hikingData.sliders.distance.max;
    initSliders();
  }
  if (type == 'time') {
    window.hikingData.sliders.time.curMin = window.hikingData.sliders.time.min;
    window.hikingData.sliders.time.curMax = window.hikingData.sliders.time.max;
    initSliders();
  }
  if (type == 'height') {
    window.hikingData.sliders.height.curMin = window.hikingData.sliders.height.min;
    window.hikingData.sliders.height.curMax = window.hikingData.sliders.height.max;
    initSliders();
  }
  getResultListExtended().then(() => {
    drawFilterTags();
    window.triggerFilter();
  });
}

const suffixify = (text, type) => {
  if (type == 'distance') return text + 'km';
  if (type == 'time') return text + 'h';
  if (type == 'height') return text + 'hm';
  return text;
}

const getResultListExtended = () => {
  let params = {};
  params.distance = {
    min: window.hikingData.sliders.distance.min,
    max: window.hikingData.sliders.distance.max,
  }
  params.time = {
    min: window.hikingData.sliders.time.min,
    max: window.hikingData.sliders.time.max,
  }
  params.height = {
    min: window.hikingData.sliders.height.min,
    max: window.hikingData.sliders.height.max,
  }
  if (window.hikingData.type == 'wanderwege') {
    params.wanderwirt = window.hikingData.checkboxes.wanderwegeWanderwirt;
    params.buggy = window.hikingData.checkboxes.wanderwegeBuggy;
    params.playground = window.hikingData.checkboxes.wanderwegePlayground;
    params.difficulty = {
      easy: window.hikingData.checkboxes.difficultyEasy,
      medium: window.hikingData.checkboxes.difficultyMedium,
      hard: window.hikingData.checkboxes.difficultyHard,
    }
  }
  else {
    params.gasthaus = window.hikingData.checkboxes.schrittewegeGasthaus;
    params.buggy = window.hikingData.checkboxes.schrittewegeBuggy;
    params.playground = window.hikingData.checkboxes.schrittewegePlayground;
  }

  return fetch(endpoints[window.hikingData.type].list, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(params),
  }).then(response => response.json())
  .then(response => {
    window.hikingData.latestList = response.list;
    updateTriggerButtonResults();
  });
}

const updateTriggerButtonResults = () => {
  let cnt = (window.hikingData.latestList || []).length;

  if (cnt == 0 && (
    window.hikingData.type == 'wanderwege'
    && window.hikingData.checkboxes.difficultyEasy == false
    && window.hikingData.checkboxes.difficultyMedium == false
    && window.hikingData.checkboxes.difficultyHard == false)
  ) {
    window.hikingData.htmlNodes.submitButton.innerHTML = "Filter anwenden";
  }
  else {
    window.hikingData.htmlNodes.submitButton.innerHTML = "Filter anwenden (" + cnt + " Ergebnisse)";
  }
}

window.formChange = e => {
  hideErrorBox();
  if (window.hikingData.type == 'wanderwege'
    && window.hikingData.checkboxes.difficultyEasy == false
    && window.hikingData.checkboxes.difficultyMedium == false
    && window.hikingData.checkboxes.difficultyHard == false
  ) {
    window.hikingData.latestList = [];
    updateTriggerButtonResults();
    return;
  }
  else {
    if (e.target && e.target.getAttribute('id') == 'search') {
      goToDetailsPage(findIdForPlaceName(window.hikingData.htmlNodes.searchInput.value));
    }
    else {
      getResultListExtended();
    }
  }
}

window.hikingData.switchView = mode => {
  if (!mode) return;
  if (mode == 'selector') {
    window.hikingData.htmlNodes.overlayRoot
      .classList.remove('c-hiking__searchbar-mode-results');
    window.hikingData.htmlNodes.overlayRoot
      .classList.add('c-hiking__searchbar-mode-selector');
  }
  if (mode == 'results') {
    window.hikingData.htmlNodes.overlayRoot
      .classList.add('c-hiking__searchbar-mode-results');
    window.hikingData.htmlNodes.overlayRoot
      .classList.remove('c-hiking__searchbar-mode-selector');
  }
}

const findIdForPlaceName = name => {
  let placeArr = window.hikingData.regions.map(region => region.places);
  let places = [];
  placeArr.map(place => {
    places = [
      ...places,
      ...place
    ]
  });
  let placeId = places.find(place => place.name == name).id;
  return placeId;
};

const findPlaceNameForPlaceId = id => {
  let placeArr = window.hikingData.regions.map(region => region.places);
  let places = [];
  placeArr.map(place => {
    places = [
      ...places,
      ...place
    ]
  });
  let placeName = places.find(place => place.id == id).name;
  return placeName;
}

const replaceGoogleMap = location => {
  if (String(location).toLowerCase() == 'index') {
    window.hikingData.htmlNodes.googleMapIndexParent.insertBefore(
      window.hikingData.htmlNodes.googleMap,
      window.hikingData.htmlNodes.googleMapIndexParent.firstChild
    );
  }
  else {
    window.hikingData.htmlNodes.googleMapDetailParent.insertBefore(
      window.hikingData.htmlNodes.googleMap,
      window.hikingData.htmlNodes.googleMapDetailBefore
    );
  }
}

const goToDetailsPage = id => {
  window.hikingData.htmlNodes.mainWrapper.classList.remove('o-main--index');
  window.hikingData.htmlNodes.mainWrapper.classList.add('o-main--detail');
  replaceGoogleMap('detail');

  //second param is callback, window.hikingData.detail is filled before cb
  initDetailPage(id, () => {
    if (window.hikingData.detail.routes && window.hikingData.detail.routes.length > 0) {
      setupMapsGPXData(window.hikingData.detail.routes[0].difficulty
        ? 'Wanderwege'
        : 'Schrittewege'
      , 0);
    }
  });
  window.setTimeout(() => {
    updateUrlForDetailPage();
  }, 1100);

  //window.location.href = 'hiking-detail.html?id='+id;
}
window.goToDetailsPage = goToDetailsPage;

const goToIndexPage = () => {
  window.hikingData.htmlNodes.mainWrapper.classList.remove('o-main--detail');
  window.hikingData.htmlNodes.mainWrapper.classList.add('o-main--index');
  replaceGoogleMap('index');
  window.hikingGoogleMap.setCenter(new google.maps.LatLng(47.990812163942756, 16.05049414062501));
  window.hikingGoogleMap.setZoom(7);
  window.hikingData.polyline.setMap(null);
  window.location.hash = '';
}
window.hikingData.goToIndexPage = goToIndexPage;

const normalizePlaceNameForUrlParam = placename => {
  return String(placename)
    .toLowerCase()
    .replace(/\s+/g,'_')
    .replace(/ü/g, 'ue')
    .replace(/ö/g, 'oe')
    .replace(/ä/g, 'ae')
    .replace(/ß/g, 'ss')
}

const getDetailUrlParam = () => {
  let base = '';
  if (window.hikingData.detail.route) {
    base = window.hikingData.detail.route;
  }
  else {
    base = normalizePlaceNameForUrlParam(window.hikingData.detail.name);
  }
  return base + '--' + window.hikingData.detail.id;
}

const updateUrlForDetailPage = () => {
  window.location.hash = getDetailUrlParam();
}

window.hikingData.switchExpandedMode = e => {
  e.preventDefault();
  if (window.hikingData.htmlNodes.overlayRoot.classList.contains('c-hiking__searchbar-mode-notexpanded')) {
    window.hikingData.htmlNodes.overlayRoot.classList.remove('c-hiking__searchbar-mode-notexpanded');
    window.hikingData.htmlNodes.overlayRoot.classList.add('c-hiking__searchbar-mode-expanded');
  }
  else {
    window.hikingData.htmlNodes.overlayRoot.classList.remove('c-hiking__searchbar-mode-expanded')
    window.hikingData.htmlNodes.overlayRoot.classList.add('c-hiking__searchbar-mode-notexpanded')
  }
}

const setupMapsGPXData = (type, routeId) => {
  if (!window.hikingData
    || !window.hikingData.detail
    || !window.hikingData.detail.routes
    || window.hikingData.detail.routes.length <= 0
  ) {
    return;
  }
  if (!type) {
    return;
  }
  if (!window.hikingGoogleMap) {
    return;
  }
  let map = window.hikingGoogleMap;
  let routeIndex = routeId || 0;
  whatwgFetch ('assets/gpx/' + type + '/' + window.hikingData.detail.routes[routeIndex].gpx)
    .then(response => response.text())
    .then(response => {
      let xmlParser = new window.DOMParser();
      let xml = xmlParser.parseFromString(response, "text/xml");
      let points = [];
      let bounds = new google.maps.LatLngBounds();
      let trackPoints = [...xml.querySelectorAll('trkpt')];
      if (window.hikingData.polyline) {
        window.hikingData.polyline.setMap(null);
      }
      trackPoints.map(trkpt => {
        let lat = trkpt.getAttribute('lat');
        let lon = trkpt.getAttribute('lon');
        let p = new google.maps.LatLng(lat, lon);
        points.push(p);
        bounds.extend(p);
      });
      window.hikingData.polyline = new google.maps.Polyline({
        // use your own style here
        path: points,
        strokeColor: "#FF00AA",
        strokeOpacity: .7,
        strokeWeight: 4
      });
      window.hikingData.polyline.setMap(map);
      map.fitBounds(bounds);
    })
}
window.hikingData.setupMapsGPXData = setupMapsGPXData;

const initDetailPage = (id, callback) => {
  let title = findPlaceNameForPlaceId(id);
  window.hikingData.htmlNodes.titleTag.innerHTML = title;
  window.hikingData.htmlNodes.breadcrumbSubTag.innerHTML = title;
  // add id as get-param
  fetch(endpoints.wanderwege.detail)
  .then(response => response.json())
  .then(response => {
    // this is custom url-param (routename/path)
    if (response.route) {
      window.hikingData.detail.route = response.route;
    }
    window.hikingData.detail.name = title;
    window.hikingData.detail.id = id;
    window.hikingData.detail.routes = response.routes;
    initRouteTabs();
    if (response.legend && response.legend.length > 0) {
      window.hikingData.htmlNodes.legendRoot.innerHTML = `
        ${response.legend.map(l => {
          return "<span class='u-icon--legend'>"
          + "<img "
          + "src='" + window.hikingData.legendMap[l].fileUrl + "'"
          + " alt='"+ window.hikingData.legendMap[l].description +"'"
          + ">"
          + "</span>"
        }).join('')}
        <span class="u-icon--info-circle u-space-ml--half" data-a11y-dialog-show="js-modal-hiking"></span>
      `;
      let modalHiking = document.getElementById('js-modal-hiking');
      let dialogHiking = new A11yDialog(modalHiking);
    }
    if (response.checkpoints && response.checkpoints.length > 0) {
      window.hikingData.htmlNodes.checkpoints.innerHTML = response.checkpoints.join(' - ');
    }
    window.hikingData.htmlNodes.anreise.innerHTML = response.anreise;
    if (response.imgURLs && response.imgURLs.length > 0) {
      window.hikingData.htmlNodes.galleryRoot.innerHTML = `
        ${response.imgURLs.map(img => {
          return "<figure class='c-gallery__item' itemprop='associateMedia' itemscope='' itemtype='http://schema.org/ImageObject'>"
          + "<a href='" + img.big + "' itemprop='contentUrl' data-size='" + img.dataSize + "'>"
          + "<img src='" +img.thumb+ "' itemprop='thumbnail' alt='Image description'>"
          + "</a>"
          + "<figcaption itemprop='caption description'>"
          + img.caption
          + "</figcaption>"
          + "</figure>"
          ;
        }).join('')}
      `;
    }
    window.hikingData.htmlNodes.charakteristika.innerHTML = response.charakteristika;
    if (response.wanderwirte && response.wanderwirte.length > 0) {
      window.hikingData.htmlNodes.wanderwirte.innerHTML = `
        ${response.wanderwirte.map(wirt => {
          return "<div class='l-grid__item'>"
          + "<h5>" + wirt.bezeichnung + "</h5>"
          + "<p>" + wirt.adresse + "</p>"
        }).join('')}
      `;
    }

    if (response.downloads && response.downloads.length > 0) {
      let lastType = '';
      window.hikingData.htmlNodes.downloads.innerHTML = `
        ${
          response.downloads.sort(function(a, b){
            if(a.typ < b.typ) { return -1; }
            if(a.typ > b.typ) { return 1; }
            return 0;
          }).map(download => {
            let newType = download.typ != lastType;
            let output = "";
            if (newType) {
              output += "<div class='l-grid__item'>";
              output += "<h5>" + download.typ + "</h5>";
            }
            output += "<a href='" + download.url + "' class='c-download__item'>";
            output += "<span class='c-download__icon u-icon--download u-space-mr--half'></span>";
            output += download.bezeichnung;
            output += "</a>";
            if (newType) {
              output += "</div>";
            }
            lastType = download.typ;
            return output;
          }).join('')
        }
      `;
    }

    /*
    downloads: [
      {
        typ: 'pdf',
        bezeichnung: 'Wanderkarte PDF',
        url: 'http://orf.at'
      },
      */
     if (callback) {
       callback();
     }
  });
}

const initRouteTabs = () => {
  let index = 1;
  let tabMarkup = '';
  if (!window.hikingData.detail.routes) {
    console.error("no routes from endpoint!");
    return;
  }
  window.hikingData.detail.routes.map( (route, idx) => {
    let markup = '<div class="c-map__tab" onclick="window.hikingData.setupMapsGPXData(\'' + (route.difficulty ? 'Wanderwege' : 'Schrittewege') +'\', ' + idx + ')">'
      + '<h4> Route ' + index + '</h4>'
      + '<span class="c-map__tab-info">'
      + 'Gehzeit: ' + route.time + 'h' + '<br>'
      + (route.difficulty ? 'Schwierigkeit: ' + (getDifficultyString(route.difficulty)) + '<br>' : '')
      + 'Strecke: ' + route.distance + 'kkm/rd' + '<br>'
      + route.steps + ' Schritte, ' + route.height + ' Höhenmeter'
      + '</span>'
      + '</div>';
    tabMarkup += markup;
    index++;
  });
  window.hikingData.htmlNodes.tabRoot.innerHTML = tabMarkup;
}

const getDifficultyString = difficulty => {
  if (difficulty == 'easy') {
    return 'Einfach';
  }
  if (difficulty == 'medium') {
    return 'Mittel';
  }
  if (difficulty == 'hard') {
    return 'Schwer';
  }
  return "Keine Angabe";
}

const handleInitialUrl = () => {
  if (window.location.hash && String(window.location.hash).length > 0) {
    let splitArr = String(window.location.hash).split('--');
    if (splitArr.length < 2) {
      return;
    }
    let placeId = parseInt(splitArr[splitArr.length - 1]);
    goToDetailsPage(placeId);
  }
}

initHikingData(handleInitialUrl);